import React, { useEffect, useRef, useState } from 'react';
import whatsapp_placeholder from '../assets/images/whatsapp_placeholder.png';
import useSnackbar from "../components/Snackbar/UseSnackbar";
import axios from 'axios';
import { API_DOMAIN } from '../components/constants';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Avatar from '@mui/material/Avatar';
import { Stack, Tooltip } from '@mui/material';
import { Badge, Button, Card, Divider, Image, Input } from 'antd';
import { useCommonApiCall } from '../components/Api/commonApiCall';
import person_avatar from '../assets/person_avatar.svg'
import loading_fountain from '../assets/images/Fountain.gif'
import loading_circle_eclipse from '../assets/images/tube-spinner.svg'
import { DownloadOutlined, LoadingOutlined, PlusCircleOutlined, SendOutlined } from '@ant-design/icons';
function WhatsappMessages() {

    const { CommonApiCall } = useCommonApiCall()

    const { SuccessSnackbar, ErrorSnackbar, InfoSnackbar, WarningSnackbar, ToastContainer } = useSnackbar();


    const [chatlist, setChatlist] = useState([]);
    const [continuationToken, setContinuationToken] = useState(null);
    const [chatlistLoading, setChatlistLoading] = useState(true);
    const [chatWindowLoading, setChatWindowLoading] = useState(true);
    const [selectedChat, setSelectedChat] = useState(null);
    const [selectedChatExchanges, setSelectedChatExchanges] = useState([]);
    const [downloadingId, setDownloadingId] = useState(null);

    const [messageText, setMessageText] = useState("");
    const [isSending, setIsSending] = useState(false);

    const scrollBottomRef = useRef(null);

    const scrollToBottom = (behavior = "auto") => {
        if (scrollBottomRef.current) {
            scrollBottomRef.current.scrollIntoView({ behavior });
        }
    };
    useEffect(() => {
        if (!chatWindowLoading) {
            setTimeout(() => scrollToBottom("auto"), 100); // Small timeout ensures DOM has rendered
        }
    }, [chatWindowLoading]);

    const handleMediaLoad = () => {
        if (scrollBottomRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = scrollBottomRef.current;

            // If the user is within 300px of the bottom, they are likely 
            // looking at new messages, so we keep them snapped to the bottom.
            // If they are further up, we do NOTHING so they don't lose their place.
            const isNearBottom = scrollHeight - scrollTop - clientHeight < 300;

            if (isNearBottom) {
                scrollToBottom("auto");
            }
        }
    };

    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function stringAvatar(name) {
        if (!name) {
            return "";
        }
        if (name.split(' ').length === 2) {
            // If name has two parts (first name and last name)
            return {
                sx: {
                    bgcolor: stringToColor(name),
                },
                children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
            };
        } else {
            // If name has only one part
            return {
                sx: {
                    bgcolor: stringToColor(name),
                },
                children: `${name.split(' ')[0][0].toUpperCase()}`, // Capitalize first letter
            };
        }
    }


    const getAllChats = async () => {
        setChatlistLoading(true);
        try {
            const response = await CommonApiCall({
                api_key: "uzdpart"
            }, "wati_messages/fetch_messages", "post");
            if (response.status) {
                setChatlist(response.data.final_data);
                setContinuationToken(response.data.continuationToken);
                SuccessSnackbar(`Retrieved chats`);
            }
        } catch (error) {
            ErrorSnackbar(error.message);
        }
        finally {
            setChatlistLoading(false);
        }
    }

    useEffect(() => {
        getAllChats();
    }, []);

    const formatChatMessageTime = (epoch) => {
        if (!epoch)
            return null
        const date = new Date(epoch * 1000);
        const now = new Date();

        // Check if it's today by comparing Year, Month, and Date
        const isToday =
            date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear();

        const timeOptions = {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };

        if (isToday) {
            return new Intl.DateTimeFormat('default', timeOptions).format(date);
        } else {
            // For older messages, include the date (e.g., "Feb 15, 12:02 PM")
            return new Intl.DateTimeFormat('default', {
                month: 'short',
                day: 'numeric',
                ...timeOptions
            }).format(date);
        }
    };

    const set_selected_chat_state = async (chatId) => {
        setSelectedChat(chatId)
        setChatWindowLoading(true);
        try {
            const response = await CommonApiCall({
                chatId,
                lastMessageId: null
            }, "wati_messages/fetch_specific_chat_messages", "post");
            if (response.status) {
                setSelectedChatExchanges(response.data.data.reverse());
                // SuccessSnackbar(`Retrieved chats`);
            }
        } catch (error) {
            ErrorSnackbar(error.message);
        }
        finally {
            setChatWindowLoading(false);
        }
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setSelectedChat(null);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const formatWhatsAppText = (text) => {
        if (!text)
            return null;
        // Regex to capture: *bold*, _italic_, ~strikethrough~, and ```monospace```
        const regex = /(\*.*?\*|__.*?__|~.*?~|```.*?```)/g;

        const parts = text.split(regex);

        return parts.map((part, index) => {
            if (!part) return null;

            // Monospace: ```text```
            if (part.startsWith('```') && part.endsWith('```')) {
                return (
                    <code key={index} className="bg-gray-100 p-0.5 rounded font-mono text-xs">
                        {part.slice(3, -3)}
                    </code>
                );
            }
            // Bold: *text*
            if (part.startsWith('*') && part.endsWith('*')) {
                return <strong key={index} className="font-bold">{part.slice(1, -1)}</strong>;
            }
            // Italic: __text__ or _text_
            if ((part.startsWith('__') && part.endsWith('__')) || (part.startsWith('_') && part.endsWith('_'))) {
                const content = part.startsWith('__') ? part.slice(2, -2) : part.slice(1, -1);
                return <em key={index} className="italic">{content}</em>;
            }
            // Strikethrough: ~text~
            if (part.startsWith('~') && part.endsWith('~')) {
                return <span key={index} className="line-through text-gray-400">{part.slice(1, -1)}</span>;
            }

            // Plain text
            return part;
        });
    };

    const handleDownload = async (url, fileName, chatId) => {
        if (downloadingId) {
            InfoSnackbar(`Wait till current download finish`)
            return;
        }
        setDownloadingId(chatId);
        try {
            const response = await axios.post(
                `${API_DOMAIN}/wati_messages/download_wati_media_file`,
                { file_name: url },
                { responseType: 'blob' } // This tells axios to keep the binary data intact
            );
            const blobUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName || 'uzdpart_media.jpg';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed", error);
        } finally {
            setDownloadingId(null); // Stop loading
        }
    };
    const handleSendMessage = async () => {
        if (!messageText.trim() || isSending) return;

        setIsSending(true);
        try {
            // Replace with your actual bridge endpoint
            const response = await axios.post("/wati_messages/send_text", {
                chatId: selectedChat, // or the recipient's phone number
                text: messageText
            });

            if (response.data.success) {
                setMessageText(""); // Clear box on success
                // Option: Re-fetch messages here or push a "temp" message to the state
                scrollToBottom("smooth");
            }
        } catch (err) {
            console.error("Error sending message:", err);
        } finally {
            setIsSending(false);
        }
    };
    return (
        <>

            <div className='border rounded drop-shadow-2 p-2' style={{ backgroundColor: "#ebebeb", height: "80vh" }}>
                <div className='flex h-full'> {/* Added h-full here */}

                    {/* LEFT PANE */}
                    <div className='mr-2 border rounded flex flex-col' style={{ backgroundColor: "#cacbcc", minWidth: "320px" }}>
                        {/* Header section (Search/Counts) */}
                        <div className='flex-none'>
                            <div className='flex justify-center p-2'>
                                <Input allowClear placeholder='Search' style={{ borderColor: "gray", width: "100%" }} />
                            </div>
                            <div className='flex justify-between px-3 pb-1 italic text-[10px]'>
                                <div>Unread : {chatlist.filter(chat => chat.unreadCount > 0).length}</div>
                                <div>Total : {chatlist.length || 0}</div>
                            </div>
                            <Divider className='m-0 p-0' />
                        </div>

                        {/* SCROLLABLE LIST: flex-1 makes it take all remaining space */}
                        <div className='flex-1 overflow-y-auto mt-1 p-1'>
                            {
                                chatlistLoading
                                    ?
                                    <div className='flex justify-center'>
                                        <img src={loading_fountain} />
                                    </div>
                                    :
                                    chatlist.length > 0 ?
                                        chatlist.map((chat) => (
                                            <div className="m-1.5 p-1 border rounded drop-shadow cursor-pointer hover:scale-105 active:scale-95 transition-transform duration-100 ease-in-out select-none" style={{ width: "300px", height: "80px", backgroundColor: `${selectedChat == chat.id ? '#7bfc68' : 'white'}` }} onClick={() => set_selected_chat_state(chat.id)}>
                                                <div className="flex">
                                                    <img style={{ width: "40px", height: "40px", borderRadius: "20px" }} src={person_avatar} alt="DP" loading="lazy" />
                                                    <div className="pl-1" style={{ width: "130px" }}>
                                                        {/* name and last message preview part */}
                                                        <div className='flex' style={{ width: "199%" }}>
                                                            <div className="truncate w-[230px] font-semibold">{chat.name}</div>
                                                            <Badge className='mr-1' id={'unread' + chat.whatsappId} count={chat.unreadCount} style={{ backgroundColor: '#52c41a' }}></Badge>
                                                        </div>
                                                        {/* <div className="italic" style={{ fontSize: "10px", color: "gray" }}>{chat.whatsappId}</div> */}
                                                        <div className='flex' style={{ width: "199%" }}>
                                                            <div id={'text' + chat.whatsappId} className="w-[230px] font-semibold line-clamp-2 overflow-hidden" style={{ fontSize: "12px", color: "gray" }}>{chat.text}</div>
                                                            <div className='flex align-bottom' style={{ fontSize: "10px", color: "gray", width: "50px" }}>{formatChatMessageTime(chat.lastMessageDate)}</div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className='m-1.5 italic flex justify-center' style={{ width: "300px", height: "80px" }}>No chats found</div>
                            }


                        </div>

                    </div>

                    {/* right pane */}
                    <Card
                        title={chatlist?.find(c => c.id === selectedChat)?.name ? (
                            <div className='flex gap-2 p-2'>
                                <img style={{ width: "40px", height: "40px", borderRadius: "20px" }} src={person_avatar} alt="DP" loading="lazy" />
                                <div>
                                    <div className='font-semibold'>
                                        {chatlist?.find(c => c.id === selectedChat)?.name}
                                    </div>
                                    <div className='text-xs text-gray-500'>
                                        {chatlist?.find(c => c.id === selectedChat)?.whatsappId}
                                    </div>
                                </div>
                            </div>
                        ) : <div className='flex gap-2 p-2' style={{ height: "40px" }}>Select a chat</div>}
                        size="small"
                        className="flex-1 flex flex-col overflow-hidden"
                        style={{ backgroundColor: "#cacbcc" }}
                        headStyle={{ backgroundColor: 'white', flex: 'none' }}
                        bodyStyle={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: 0 }}
                    >
                        {selectedChat ? (
                            chatWindowLoading ? (
                                <div className='flex flex-1 justify-center items-center'>
                                    <img style={{ width: "100px" }} src={loading_circle_eclipse} />
                                </div>
                            ) : (
                                <>
                                    {/* 1. SCROLLABLE MESSAGE AREA */}
                                    <div className='flex-1 overflow-y-auto p-4' style={{ backgroundColor: "#cacbcc" }}>
                                        <Tooltip title='Load old chats'>
                                            <div className='flex justify-center cursor-pointer py-2'>
                                                <PlusCircleOutlined  />
                                            </div>
                                        </Tooltip>

                                        {selectedChatExchanges.map((chat) => (
                                            chat.eventType === 'ticket' ? (
                                                <div key={chat.id} className='flex justify-center'>
                                                    <Divider className='text-xs'>
                                                        {chat?.eventDescription + ' - ' + formatChatMessageTime(new Date(chat?.created).getTime() / 1000)}
                                                    </Divider>
                                                </div>
                                            ) : (
                                                <div
                                                    key={chat.id}
                                                    className='flex w-full'
                                                    style={{ justifyContent: chat.owner || chat?.finalText ? 'flex-end' : 'flex-start' }}
                                                >
                                                    <div className={`whitespace-pre-wrap relative mt-1 mb-1 p-2 max-w-[70%] rounded-lg border shadow-sm
                                    ${chat?.owner || chat?.finalText
                                                            ? 'bg-[#dcf8c6] rounded-br-none mr-2 after:border-l-[10px] after:border-l-[#dcf8c6] after:-right-2'
                                                            : 'bg-white rounded-bl-none ml-2 after:border-r-[10px] after:border-r-white after:-left-2'}
                                    after:content-[''] after:absolute after:bottom-0 after:w-0 after:height-0 after:border-t-[10px] after:border-t-transparent
                                `}>
                                                        {/* Image message */}
                                                        {chat.type === 'image' && (
                                                            <div className='flex justify-center relative mb-1' style={{ overflow: 'visible' }}>
                                                                <Image
                                                                    style={{ maxHeight: "250px", display: 'block' }}
                                                                    className='rounded'
                                                                    src={chat.data}
                                                                    onLoad={handleMediaLoad}
                                                                />
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        handleDownload(chat.data_original, `file_${chat.id}.jpg`, chat.id);
                                                                    }}
                                                                    className={`bg-black/70 text-white rounded-full flex items-center justify-center transition-all ${downloadingId === chat.id ? 'cursor-not-allowed opacity-100' : 'cursor-pointer hover:scale-110'}`}
                                                                    style={{
                                                                        position: 'absolute', top: '10px', right: '10px', zIndex: 99,
                                                                        width: '35px', height: '35px', boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                                                                        pointerEvents: downloadingId ? 'none' : 'auto'
                                                                    }}
                                                                >
                                                                    {downloadingId === chat.id ? <LoadingOutlined /> : <DownloadOutlined />}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Video message */}
                                                        {chat.type === 'video' && (
                                                            <div className='relative group flex justify-center mb-1'>
                                                                <video src={chat.data} className="max-h-[360px] rounded" controls onLoadedData={handleMediaLoad}>
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        handleDownload(chat.data_original, `file_${chat.id}.mp4`, chat.id);
                                                                    }}
                                                                    className={`bg-black/70 text-white rounded-full flex items-center justify-center transition-all ${downloadingId === chat.id ? 'cursor-not-allowed opacity-100' : 'cursor-pointer hover:scale-110'}`}
                                                                    style={{
                                                                        position: 'absolute', top: '10px', right: '10px', zIndex: 99,
                                                                        width: '35px', height: '35px', boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                                                                        pointerEvents: downloadingId ? 'none' : 'auto'
                                                                    }}
                                                                >
                                                                    {downloadingId === chat.id ? <LoadingOutlined /> : <DownloadOutlined />}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {chat?.replySourceMessage && (
                                                            <div className='flex border rounded bg-white/50 mb-1 p-1 text-xs opacity-80'>
                                                                <div style={{ width: "3px", backgroundColor: "#8349e6", marginRight: '5px' }}></div>
                                                                <div className='line-clamp-2'>
                                                                    {formatWhatsAppText(chat?.replySourceMessage?.text)}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {formatWhatsAppText(chat?.text || chat?.finalText)}

                                                        <div className="text-[10px] text-gray-500 text-right mt-1 leading-none">
                                                            {chat?.owner && chat?.operatorName ? chat.operatorName + ' - ' : null}
                                                            {formatChatMessageTime(chat?.timestamp || new Date(chat?.created).getTime() / 1000)}
                                                            {chat.owner ? ' - ' + (chat.statusString || '') : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        ))}
                                        <div ref={scrollBottomRef} />
                                    </div>

                                    {/* 2. STICKY FOOTER REPLY BOX */}
                                    <div className='flex-none p-3 bg-white flex items-end gap-2'>
                                        <div className='flex-1 bg-[#f0f2f5] rounded-xl px-4 py-1 border border-transparent focus-within:border-[#7bfc68] transition-all duration-200'>
                                            <textarea
                                                rows={1}
                                                value={messageText}
                                                onChange={(e) => setMessageText(e.target.value)}
                                                disabled={isSending}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && !e.shiftKey) {
                                                        e.preventDefault();
                                                        handleSendMessage();
                                                    }
                                                }}
                                                placeholder="Type a message..."
                                                className='w-full outline-none resize-none bg-transparent pt-2 text-sm text-gray-700'
                                                style={{ minHeight: '32px', maxHeight: '150px' }}
                                            />
                                            <div className='text-[9px] text-gray-400 text-right pb-1'>
                                                {messageText.length} characters
                                            </div>
                                        </div>

                                        <Button
                                            type="primary"
                                            shape="circle"
                                            icon={isSending ? <LoadingOutlined /> : <SendOutlined />}
                                            onClick={handleSendMessage}
                                            disabled={!messageText.trim() || isSending}
                                            className="flex items-center justify-center shadow-md"
                                            style={{
                                                width: '44px',
                                                height: '44px',
                                                backgroundColor: messageText.trim() ? '#075e54' : '#d1d1d1',
                                                borderColor: 'transparent'
                                            }}
                                        />
                                    </div>
                                </>
                            )
                        ) : (
                            /* PLACEHOLDER WHEN NO CHAT SELECTED */
                            <div className='flex-1 flex flex-col justify-center items-center bg-[#cacbcc]'>
                                <img src={whatsapp_placeholder} className="w-48 opacity-50" />
                                <div className='font-bold text-lg mt-4'>
                                    Select a chat to start messaging
                                </div>
                            </div>
                        )}
                    </Card>
                </div>
            </div>
            <ToastContainer />
        </>

    );
};

export default WhatsappMessages;
